/* eslint-disable react-hooks/exhaustive-deps */
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import  { useEffect, useState } from 'react'
import { db } from '../Auth/Config/Config';
import { geocoder } from '../Auth/Config/GoogleMaps';

export default function LocationCheck() {
    const [result,setresult] = useState(true);
    const auth = getAuth();


     useEffect(() => {
       const unsubscribe = onAuthStateChanged(auth, (user) => {
         if (user) {
           preCheckUser(user.uid);
         } else {
         }
       });
       return unsubscribe;
     }, [auth]);
     const preCheckUser=async(uid)=>{
        const userRef = doc(db, "users", uid);
        const docSnap = await getDoc(userRef);
          if (docSnap.exists) {
                    const data = docSnap.data();
                    if (data&&data.place === "") {
                                 checkLocation();
                    }

          }
     }

     const checkLocation=async()=>{
            if ("geolocation" in navigator) {
              navigator.geolocation.getCurrentPosition(
                async (position) => {
                  const { latitude, longitude } = position.coords;
                  let latlng;
                 if (window.google && window.google.maps) {
                   latlng = new window.google.maps.LatLng(
                     latitude,
                     longitude
                   );
                 } else {
                   console.error("Google Maps API is not loaded");
                 }
                  geocoder.geocode(
                    { location: latlng },
                    async (results, status) => {
                      if (results && results.length > 0) {
                        let place = "";
                        let state = "";
                        let country = "";
                        const placeData = results[0].address_components; // Access address components
                        // const co_ordinates = results[0].geometry.location;
                        for (const component of placeData) {
                          if (
                            component.types.includes(
                              "administrative_area_level_1"
                            )
                          ) {
                            state = component.long_name; // Extract state/province
                          } else if (component.types.includes("country")) {
                            country = component.long_name; // Extract country
                          } else if (
                            component.types.includes("locality", "political")
                          ) {
                            place = component.long_name; // Extract locality (city)
                          }
                        }
                        if (auth.currentUser) {
                          await updateDoc(
                            doc(db, "users", auth.currentUser.uid),
                            {
                              place: place,
                              state: state,
                              country: country,
                              lat: latitude.toString(),
                              long: longitude.toString(),
                            }
                          ).catch((error) => {
                            console.log(error);
                          });
                          setresult(place);
                        }
                      } else {
                        console.error(
                          "No results found for the current location."
                        );
                      }
                    }
                  );
                },
                (error) => {
                  console.error(
                    "Error getting current location:",
                    error.message
                  );
                }
              );
            } else {
              console.error("Geolocation is not supported by this browser.");
            }
     }
  return result
}
